// components
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import MotionPhotosAutoOutlinedIcon from "@mui/icons-material/MotionPhotosAutoOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
// routes
import { PATH_DASHBOARD } from "../../routes/paths";

export const sidebarConfig = [
  {
    subheader: "Account Settings",
    items: [
      {
        title: "Personal Info",
        path: PATH_DASHBOARD.general.account,
        icon: <AccountBalanceWalletOutlinedIcon />,
      },
      {
        title: "My Account",
        path: PATH_DASHBOARD.general.settings,
        icon: <SettingsOutlinedIcon />,
      },
      // {
      //   title: "My Wallet",
      //   path: PATH_DASHBOARD.general.root,
      //   icon: <AccountBalanceWalletOutlinedIcon />,
      // },
    ],
  },
  {
    subheader: "Listings",
    items: [
      {
        title: "My Bookings",
        path: PATH_DASHBOARD.bookings,
        icon: <MenuBookOutlinedIcon />,
      },
      {
        title: "My Transactions",
        path: PATH_DASHBOARD.transactions,
        icon: <PaymentsOutlinedIcon />,
      },
      {
        title: "Saved Wishlist",
        path: PATH_DASHBOARD.wishlist,
        icon: <FavoriteBorderOutlinedIcon />,
      },
      {
        title: "Messages",
        path: PATH_DASHBOARD.messages,
        icon: <ChatOutlinedIcon />,
      },
      {
        title: "Reviews",
        path: PATH_DASHBOARD.reviews,
        icon: <VisibilityOutlinedIcon />,
      },
      {
        title: "Refer a Friend",
        path: PATH_DASHBOARD.referral,
        icon: <GroupsOutlinedIcon />,
      },
    ],
  },
  {
    subheader: "Support",
    items: [
      {
        title: "Visit the Help center",
        path: "https://cribsfinder.com/faq",
        icon: <HelpOutlineOutlinedIcon />,
      },
      {
        title: "How Cribsfinder Works",
        path: "https://cribsfinder.com/about",
        icon: <MotionPhotosAutoOutlinedIcon />,
      },
    ],
  },
];
